import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type CharacteristicGroupsWithCharacteristicsResponse as SchemaCharacteristicGroupsWithCharacteristicsResponse } from '../schemas/CharacteristicGroupsWithCharacteristicsResponse';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Characteristics
 */
export const GetCharacteristicGroupsWithCharacteristicsContentType = '' as const;
export type GetCharacteristicGroupsWithCharacteristicsRequest = void;
export type GetCharacteristicGroupsWithCharacteristicsResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful retrieval of characteristic groups with characteristics
     */
    '200': {
        'application/json': SchemaCharacteristicGroupsWithCharacteristicsResponse;
    };
};
export type GetCharacteristicGroupsWithCharacteristicsResponseSuccess =
    GetCharacteristicGroupsWithCharacteristicsResponses['200']['application/json'];
export type GetCharacteristicGroupsWithCharacteristicsSearchParams = {
    search_text?: string;
    category_slug?: string;
};
export type GetCharacteristicGroupsWithCharacteristicsPathParameters = undefined;
export const GetCharacteristicGroupsWithCharacteristicsUrl = '/characteristics/groups' as const;
export const GetCharacteristicGroupsWithCharacteristicsMethod = 'GET' as const;
export const getGetCharacteristicGroupsWithCharacteristicsUrl = (
    _params?: GetCharacteristicGroupsWithCharacteristicsPathParameters
) => GetCharacteristicGroupsWithCharacteristicsUrl;
